import { useMutation } from '@tanstack/react-query'
import { TableCell, TableRow } from '@/components/ui/table'
import { postJSON } from '@/lib/api'
import { RemoveEntryMenu } from '@/components/events/event-waitlist-actions'
import { WaitlistStatus, type WaitlistEntry } from './event-waitlist'

export function WaitlistOfferRow({
  eventId,
  entry,
  onOffer,
  onRemove,
  className,
}: {
  eventId: number
  entry: WaitlistEntry
  onOffer: () => void
  onRemove: (entryId: number) => void
  className?: string
}) {
  const mutation = useMutation({
    mutationFn: () => postJSON(`/api/v1/events/${eventId}/waitlist_entries/${entry.id}/offer`, {}),
    onSuccess: onOffer,
  })
  return (
    <TableRow className={className}>
      <TableCell className="py-2 tabular-nums">{entry.position || '—'}</TableCell>
      <TableCell className="py-2">
        <p className="font-medium">{entry.name}</p>
        <p className="text-caption text-muted-foreground">{entry.email}</p>
      </TableCell>
      <TableCell className="py-2">
        <p>{entry.party_size}</p>
        <p className="text-caption text-muted-foreground">{entry.ticket_type.name}</p>
      </TableCell>
      <TableCell className="whitespace-nowrap py-2 text-muted-foreground">{entry.joined}</TableCell>
      <TableCell className="py-2">
        <WaitlistStatus entry={entry} />
      </TableCell>
      <TableCell className="py-2 text-right">
        <RemoveEntryMenu
          entry={entry}
          onRemove={onRemove}
          onOffer={entry.status === 'waiting' ? () => mutation.mutate() : undefined}
          offerPending={mutation.isPending}
        />
        {mutation.isError && <p className="text-caption text-destructive">Could not send offer.</p>}
      </TableCell>
    </TableRow>
  )
}
